import React from "react";
import PropTypes from "prop-types";

import AuthButton from "../button";

const EmailButton = ({ onClick, children }) => {
  const clickHandler = () => {
    onClick();
  };

  return (
    <AuthButton
      dataQa="email-button"
      iconAlt="email button"
      iconSrc="/assets/icons/auth-email.svg"
      onClick={clickHandler}
    >
      {children}
    </AuthButton>
  );
};

EmailButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  children: PropTypes.string.isRequired,
};

export default EmailButton;
